<template>
	<div class="leaving">
		<Header />
		<div class="leaving_box">
			<div class="form_box">
				<div class="form_box_l">
					<p>请您填写表单后提交给我们</p>
					<p>我们会尽快与您取得联系</p>
					<p  class="form_txt_fff">全国服务热线:</p>
					<div class="tels_box" style="margin-top:10px">
						<div>400  650  2790</div>
					</div>
					<div class="tels_box" style="margin-top:11px">
						<div>010-62965536</div>
					</div>
					<!-- tel_box -->
					<p class="form_txt_fff" style="margin-top:10px">总部地址：</p>
					<div class="form_box_l_b">
						<p class="form_txt_fff font" style="color:#c5c5c5">
							北京市海淀区上地信息路1号国际创业园A座四层
						</p>
						<!-- <p>大陆总公司：北京某某在线服务网络公司</p>
						<p>香港公司：某某国际科技有限公司</p>
						<p>北京省互联网协会成员单位</p>
						<p>地址：北京市顺城大街</p>
						<p>网址：www.baidu.com</p> -->
					</div>
					<!-- 底部 -->
				</div>
				<div class="form_box_r">
					<p>请填写您的信息</p>
					<el-form
						:model="ruleForm"
						status-icon
						:rules="rules"
						ref="ruleForm"
						class="demo-ruleForm"
					>
						<el-form-item prop="bmName">
							<el-input
								v-model="ruleForm.bmName"
								autocomplete="off"
								placeholder="姓名"
							></el-input>
						</el-form-item>
						<el-form-item prop="bmPhone">
							<el-input
								v-model="ruleForm.bmPhone"
								autocomplete="off"
								placeholder="电话"
							></el-input>
						</el-form-item>
						<el-form-item prop="bmQq">
							<el-input v-model="ruleForm.bmQq" placeholder="QQ"></el-input>
						</el-form-item>
						<el-form-item prop="bmEmail">
							<el-input
								v-model="ruleForm.bmEmail"
								placeholder="邮箱"
							></el-input>
						</el-form-item>
						<el-form-item prop="bmContent">
							<el-input
								type="textarea"
								v-model="ruleForm.bmContent"
								placeholder="内容"
							></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitForm">提交</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="form_box_b">
					<p>请您填写表单后提交给我们</p>
					<p>我们会尽快与您取得联系</p>
					<p  class="form_txt_fff">全国服务热线:</p>
					<div class="tels_box">
						<div>400  650  2790</div>
					</div>
					<div class="tels_box">
						<div>010-62965536</div>
					</div>
					<!-- tel_box -->
					<p class="form_txt_fff">总部地址：</p>
					<div class="form_box_l_b">
						<p class="form_txt_fff font" style="color:#c5c5c5">
							北京市海淀区上地信息路1号国际创业园A座四层
						</p>
					</div>
					<!-- 底部 -->
				</div>
			</div>
		</div>
		<Footer />
		<div v-if="showTips" style="width:330px;height:160px;background:#fff;border-radius:10px;position:fixed;top:0;left:0;right:0;bottom:0;margin:auto;z-index:9999">
			<p style="text-align:left;margin-left:20px;font-size:14px;font-weight:bold;margin-top:15px">国基科技提示您：</p>
			<p style="font-size:14px;text-align:center;">提交成功</p>
			<p @click="hideTips" style="display:inline-block;width:80px;height:30px;text-align:center;line-height:30px;margin-top:15px;margin-left:220px;background:#409EFF;color:#fff">确定</p>
		</div>
		<div v-if="showError" style="width:330px;height:160px;background:#fff;border-radius:10px;position:fixed;top:0;left:0;right:0;bottom:0;margin:auto;z-index:9999">
			<p style="text-align:left;margin-left:20px;font-size:14px;font-weight:bold;margin-top:15px">国基科技提示您：</p>
			<p style="font-size:14px;text-align:center;">请输入正确的信息</p>
			<p @click="hideerrorTips" style="display:inline-block;width:80px;height:30px;text-align:center;line-height:30px;margin-top:15px;margin-left:220px;background:#409EFF;color:#fff">确定</p>
		</div>
	</div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Header from '../../components/Header.vue'
import Axios from 'axios'
export default {
	components: { Header, Footer },
	data() {
		var checkNick = (rule, value, callback) => {
			if (!value.trim()) {
				return callback(new Error('姓名不能为空'))
			}
			setTimeout(() => {
				if (value.length < 2 || value.length > 11) {
					callback(new Error('请输入正确名字格式'))
				}
			}, 1000)
		}
		var checkTel = (rule, value, callback) => {
			var reg_tel =
				/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
			if (!value) {
				return callback(new Error('电话号不能为空'))
			}
			setTimeout(() => {
				if (value.length !== 11 || !reg_tel.test(value)) {
					callback(new Error('请输入正确电话号'))
				}
			}, 1000)
		}
		var checkQQ = (rule, value, callback) => {
			var reg_tel = /\d{5,11}/
			if (!value.trim()) {
				return callback(new Error('qq不能为空'))
			}
			setTimeout(() => {
				if (!reg_tel.test(value) || value.length > 10) {
					callback(new Error('请输入正确qq号'))
				}
			}, 1000)
		}
		var checkEmail = (rule, value, callback) => {
			var reg_tel = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
			if (!value) {
				return callback(new Error('邮箱不能为空'))
			}
			setTimeout(() => {
				if (!reg_tel.test(value)) {
					callback(new Error('请输入正确邮箱号'))
				}
			}, 1000)
		}
		var checkContent = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('内容不能为空'))
			}
		}
		return {
			ruleForm: {
				bmName: '',
				bmPhone: '',
				bmQq: '',
				bmEmail: '',
				bmContent: '',
			},
			showTips:false,
			showError:false,
			rules: {
				bmName: [{ validator: checkNick, trigger: 'blur' }],
				bmPhone: [{ validator: checkTel, trigger: 'blur' }],
				bmQq: [{ validator: checkQQ, trigger: 'blur' }],
				bmEmail: [{ validator: checkEmail, trigger: 'blur' }],
				bmContent: [{ validator: checkContent, trigger: 'blur' }],
			},
		}
	},
	methods: {
		submitForm() {
			if(this.ruleForm.bmName==''||this.ruleForm.bmPhone==''||this.ruleForm.bmQq==''||this.ruleForm.bmEmail==''||this.ruleForm.bmContent==''){
				this.showError=true
			}else{
			Axios({
				url:'/apiv2/bmessage/add',
				data: { ...this.ruleForm },
				method: 'POST',
			}).then((res) => {
				if(res.data.data.bmContent!=''&&res.data.data.bmEmail!=''&&res.data.data.bmName!=''&&res.data.data.bmPhone!=''&&res.data.data.bmQq!=''){
					this.showTips=true
				}else{
					this.showError=true
				}
				
			})}
			// this.$refs[formName].validate((valid) => {
			// 	if (valid) {
			// 		alert('submit!')
			// 	} else {
			// 		console.log('error submit!!')
			// 		return false
			// 	}
			// })
		},
		hideTips(){
			this.showTips=false
		},
		hideerrorTips(){
			this.showError=false
		}
	},
}
</script>

<style lang="scss" scoped>
::v-deep font{
	line-height: 40px;
}
::v-deep span{
	line-height: 40px;
}
::v-deep p{
	line-height: 40px;
}
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	@import './index.scss';
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m-index.scss';
}
</style>